function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.214 14.405L6.83 20l-.19-.166-.266-.221v-4.24c0-.23-.014-.461-.043-.69 0 0-.39-.384-.635-.632H.476l-.231-.234L0 13.572V.484L.259.206.494 0h19.098l.186.188.222.274v13.065l-.21.305-.284.219-6.482.015-.81.34z",
  fill: "params(fill) white"
});

function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgChat;